<app-navbar appHideBreadcrumb *ngIf="this.jobLoaded">
    <h2>{{job.jobTitle}}</h2>
    <div class="job-subtitle">
        <div class="employment-type" *ngFor="let jobType of job.workType">
            <a class="round-button green-background">{{jobType  | enumTransform}}</a>
        </div>
        <div class="job-location">
            <i class="icofont-location-pin"></i>
            {{job.companyName}} - {{job.city}}, {{job.country}}
        </div>
        <div class="job-posted-date">
            <i class="icofont-calendar"></i>
            <span> Publicat pe: {{job.jobPostingDate | date:"dd-MM-yyyy"}}</span>
        </div>
    </div>
</app-navbar>

<div *ngIf="this.jobLoaded" class="job-details-area pt-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <app-form-message [success]="formResponse" *ngIf="formSent"
                                  [customSuccessMessage]="'Jobul a fost clonat cu succes! Vei fi redirectionat in scurt timp.'"></app-form-message>

                <app-form-message [success]="statusChanged" *ngIf="statusSend"
                                  [customSuccessMessage]="'Statusul jobului a fost schimbat cu succes!'"></app-form-message>
                <app-form-message [success]="statusChanged" *ngIf="statusFail"
                                  [customSuccessMessage]="'Nu aveti perimisiunea sa schimbati statusul acestui job!'"></app-form-message>
            </div>
            <div class="col-lg-8">
                <div class="job-details-item">
                    <div class="job-image-container" *ngIf="job.photoPath !== 'string'">
                        <!-- <h3>Prezentare generala</h3> -->
                        <img src="{{job.photoPath}}" class="job-image img-fluid">
                    </div>
                    <h3>Prezentare generala</h3>
                    <div class="job-description">
                        <h5>Descrierea postului</h5>
                        <!-- <p>{{job.jobDescription}}</p> -->
                        <p class="pb-5" [innerHtml]="job.jobDescription"></p>
                        <h5 class="mt-3">Beneficii</h5>
                        <p class="pb-5" [innerHtml]="job.benefits"></p>
                        <!-- <p>{{job.benefits}}</p> -->
                        <h5 class="mt-3">Pachet salarial</h5>
                        <p *ngIf="job.confidentialSalaryLevel">Confidențial</p>
                        <div *ngIf="!job.confidentialSalaryLevel">
                            <p class="mb-1">Interval salarial: {{job.minimumSalary}} - {{job.maximumSalary}}</p>
                            <p class="mb-1">Bonus: {{job.bonus | titlecase}}</p>
                            <p class="mb-1">Valoare medie bonus: {{job.averageBonusValue}}</p>
                        </div>
                        <h5 class="mt-3">Alte beneficii</h5>
                        <span *ngIf="job.otherBenefits">
                            <p *ngFor="let benefit of job.otherBenefits" class="mb-1">{{benefit}}</p>
                        </span>

                        <h5 class="mt-3">Numarul de joburi disponibile</h5>
                        <p>{{job.openPositions}}</p>

                        <h5 class="mt-3">Program de lucru</h5>
                        <p>{{job.workProgram | enumTransform}}</p>

                        <h5 class="mt-3">Spatiu de lucru</h5>
                        <p>{{job.workSpace | titlecase}}</p>

                        <h5 class="mt-3">Efort fizic</h5>
                        <span *ngIf="job.physicalEffortRequired">
                            <p>{{job.physicalEffortRequired.type | titlecase}}</p>
                        </span>

                        <h5 class="mt-3">Tip contract</h5>
                        <p>{{job.contractType | enumTransform}}</p>

                        <h5 class="mt-3">Disponibilitate job</h5>
                        <p>{{job.jobDisponibility | enumTransform}}</p>

                        <h5 class="mt-3">Posibilitati de cariera</h5>
                        <p *ngFor="let posib of job.careerPossibility" class="mb-1"> {{ posib | enumTransform}}</p>

                        <h5 class="mt-3">Posibilitate de relocare</h5>
                        <p>{{job.relocationPossibility | enumTransform}}</p>

                        <h5 class="mt-3">Facilitati de relocare incluse</h5>
                        <p>{{job.relocationPackageIncluded | enumTransform}}</p>

                        <h5 class="mt-3">Disponibilitate la deplasare</h5>
                        <p>{{job.availableForTraveling}}</p>

                        


                        <div *ngIf="job.videoLink">
                            <h5>Prezentare video</h5>
                            <iframe width="100%" height="415"
                                    [src]="videoLink | safe"></iframe>

                        </div>

                    </div>

                    <h3 class="mt-3">Cerinte job</h3>
                    <div class="job-description">
                        <h5>Candidatul ideal</h5>
                        <!-- <p>{{job.idealCandidate}}</p> -->
                        <p [innerHtml]="job.idealCandidate"></p>
                        <h5>Permis de conducere</h5>
                        <p>{{job.driverLicense}}</p>

                        <h5>Limbi straine</h5>
                        <p *ngFor="let lang of job.foreignLanguage | keyvalue">
                            {{lang.value.language}} - {{lang.value.level}}
                        </p>

                        <h5>Experientă de lucru necesară</h5>
                        <p *ngFor="let experiance of job.similarExperience | keyvalue">
                            {{experiance.value.department}} - {{experiance.value.year}} ani
                        </p>
                        <p> Experientă totală necesară : {{job.totalExperience}} ani</p>

                        <p> Permis legal de muncă obligatoriu: <span *ngIf="job.legalWorkPermitMandatory === true">Necesar</span> <span *ngIf="job.legalWorkPermitMandatory === false">Nu este necesar</span></p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <!-- <h3>Rezumat job</h3> -->
                <div class="job-details-item">
                    <div class="job-overview job-specs">

                        <ul>
                            <li *ngIf="job.jobPostingDate !== null && job.jobPostingDate !== ''">
                                <i class="icofont-building"></i>
                                <p>Compania: </p>
                                <a class="no-decoration" *ngIf="companyLoaded" [href]="companyPageLink">{{companyData.companyName}}</a>
                                <!--                                <span *ngIf="postedDaysAgo > 1">Postat acum {{job.postedDaysAgo}} zile</span>-->
                                <span *ngIf="postedDaysAgo < 1">Postat astazi</span>
                            </li>

                            <li *ngIf="job.jobJobLocation !== null && job.jobJobLocation !== ''">
                                <i class="icofont-location-pin"></i>
                                <p>Locatie job</p>
                                <span class="d-inline-flex flex-wrap">
                                    <span *ngFor="let county of job.city">
                                        {{county + ","}}&nbsp;
                                    </span>
                                    {{job.country}}
                                </span>
                            </li>
                            <li *ngIf="job.activitySector !== null && job.activitySector !== ''">
                                <i class="icofont-label"></i>
                                <p>Industrie</p>
                                <span>{{job.activitySector}}, {{job.activitySubSector}}</span>
                            </li>
                            <li *ngIf="job.department !== null && job.department !== ''">
                                <i class="icofont-label"></i>
                                <p>Departament</p>
                                <span>{{job.department}}</span>
                            </li>

                            <li *ngIf="job.experienceLevel !== null && job.experienceLevel !== 'string'">
                                <i class="icofont-briefcase"></i>
                                <p>Nivel cariera</p>
                                <span>{{job.experienceLevel | enumTransform}}</span>
                            </li>
                            <li *ngIf="job.workType !== null && job.workType !== 'string'">
                                <i class="icofont-briefcase"></i>
                                <p>Tip job:</p>
                                <span *ngFor="let jobType of job.workType">{{jobType  | enumTransform}}</span>
                            </li>
                            <li *ngIf="job.studies !== null && job.studies !== ''">
                                <i class="icofont-university"></i>
                                <p>Nivel studii necesare</p>
                                <span>{{job.studies | enumTransform}}</span>
                            </li>
                            <li *ngIf="job.salary !== null && job.salary !== 0">
                                <i class="icofont-money"></i>
                                <p>Salariu oferit:</p>
                                <span>{{job.salary}}</span>
                            </li>
                            <li *ngIf="job.startDate !== null && job.startDate !== ''">
                                <i class="icofont-clock-time"></i>
                                <p>Valabil pana la: </p>
                                <span>{{job.startDate | date:"dd-MM-yyyy"}}
                                    pana la {{job.endDate | date:"dd-MM-yyyy"}}</span>
                            </li>

                        </ul>

                        <div class="company-buttons-container" *ngIf="userIsAuthor || isSuperAdmin">
                            <a routerLink="/aplicatii/{{jobId}}" class="user-button round-button blue-background">Vezi
                                aplicatii</a>
                            <button class="user-button round-button orange-background border-0"
                                    (click)="duplicateJob()">Duplica job
                            </button>
                            <a routerLink="/editare-job/{{jobId}}" class="user-button round-button green-background">Editeaza
                                acest job</a>
                            <button class="user-button round-button yellow-background border-0"
                                    (click)="statusModal.show()">
                                Schimba status
                            </button>
                        </div>

                        <!--Change Status Modal Component-->
                        <app-modal #statusModal>
                            <div class="app-modal-header">
                                <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                            </div>
                            <div class="app-modal-body">

                                <select [(ngModel)]="jobStatus">
                                    <option selected disabled value="">Selecteaza un status</option>
                                    <option value="Published">Publicat</option>
                                    <option value="Draft">Ciorna</option>
                                    <option value="Pending_review">In asteptare</option>
                                    <option value="Expired">Expirat</option>
                                    <option value="Archived">Arhivat</option>
                                </select>

                                <span class="error-msg d-block">
                                    Esti sigur ca vrei sa schimbi statusul acestui job in {{jobStatus | enumTransform}}?
                                </span>


                            </div>
                            <div class="app-modal-footer">
                                <button type="button"
                                        class="btn btn-danger mr-2"
                                        (click)="statusModal.hide()">
                                    Renunta
                                </button>
                                <button type="button" class="btn btn-success"
                                        (click)="changeJobStatus(job.id, jobStatus, job.userId); statusModal.hide()">
                                    Actualizeaza
                                </button>
                            </div>
                        </app-modal>

                        <div class="candidate-buttons-container" *ngIf="!userIsAuthor">
                            <a routerLink="/aplica/{{jobId}}" *ngIf="!userApplied && isCandidate"
                               class="user-button round-button green-background">Aplica la acest job</a>

                            <button *ngIf="!selected && isCandidate" type="button" class="fav-button"
                                    (click)="toggleFav(jobId)">Adauga
                                la favorite <i class="icofont-heart"></i></button>
                            <button *ngIf="selected && currentUserID && isCandidate" type="button" class="fav-button"
                                    (click)="toggleFav(jobId)">Sterge din favorite <i
                                    class="icofont-ui-love-broken"></i></button>
                            <a *ngIf="selected && currentUserID && isCandidate" class="view-fav-list"
                               routerLink="/joburi-favorite">Vezi
                                lista de favorite</a>

                            <a routerLink="/aplicatie/{{applicationId}}" *ngIf="userApplied"
                               class="user-button round-button green-background">Vezi aplicatia</a>
                        </div>


                    </div>


                    <h4>Distribuie jobul</h4>
                    <div class="job-overview job-specs">
                        <share-buttons [theme]="'default'"
                                       [include]="['facebook','linkedin', 'whatsapp', 'telegram','messenger','sms','email','print','copy']"
                                       [show]="3"
                                       [url]=currentUrl
                        ></share-buttons>
                    </div>

                    <h4>Locatie job</h4>
                    <div class="job-location-container" *ngFor="let city of jobLocationLinks">
                        <iframe [src]="city | byPassSecurity"
                                width="100%" height="300" style="border:0;" allowfullscreen=""
                                aria-hidden="false" tabindex="0"></iframe>
                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <h4>Alte joburi asemanatoare</h4>
                <div class="similar-jobs-container">
                    <div class="row">
                        <div class="col-12">
                            <app-similar-jobs></app-similar-jobs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
